import Module from '../../module';
import scroll from '../../../libs/scroll/scroll';

interface OptionsInterface {
	cssId: {
		anim?: {
			investorsFinancialStatementsHeroContentSectionHeaderCls: string;
		}
	},

	slug: string
}

class Hero extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('Investors Financial Statements Hero Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsFinancialStatementsHeroContentSectionHeaderCls || '', 'investors_financial_statements_hero', { animCls: 'animate__fadeInLeft25P', once: true});
	}

	bind() {
		this.msg('bind');
	}
}

export default Hero;